import { ReactNode } from 'react';
import { hasRole } from '~/hooks/has-role.hook';
import useViewer from '~/hooks/viewer.hook';

interface HasRoleProps {
  requiredRole: string | Array<string>;
  children: ReactNode;
}

const HasRole = ({ children, requiredRole }: HasRoleProps) => {
  const { viewer } = useViewer();
  const canShowChildren = hasRole({
    viewer,
    requestedRole: requiredRole,
  });

  if (canShowChildren === false) {
    return null;
  }

  return <>{children}</>;
};

export default HasRole;
